import FormField from '@cloudscape-design/components/form-field';
import CSDMultiselect, {
  MultiselectProps,
} from '@cloudscape-design/components/multiselect';
import { get } from 'lodash';
import { Controller, useFormContext } from 'react-hook-form';

type Props = {
  name: string;
  options: MultiselectProps.Options;
  label?: string;
  description?: string;
  placeholder?: string;
  disabled?: boolean;
  stretch?: boolean;
  className?: string;
  rules?: any;
  keepOpen?: boolean;
};

const MultiSelect = ({
  name,
  options,
  label,
  description,
  placeholder = '',
  disabled = false,
  stretch = false,
  className = '',
  rules = undefined,
  keepOpen = true,
}: Props) => {
  const { control, formState } = useFormContext();

  return (
    <FormField
      stretch={stretch}
      description={description}
      label={label}
      className={className}
      errorText={get(formState.errors, name)?.message as string | undefined}
    >
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field }) => (
          <CSDMultiselect
            {...field}
            placeholder={placeholder}
            disabled={disabled}
            selectedOptions={field.value}
            onChange={({ detail }) => field.onChange(detail.selectedOptions)}
            options={options}
            keepOpen={keepOpen}
            tokenLimit={2}
            i18nStrings={{
              tokenLimitShowFewer: 'Weniger anzeigen',
              tokenLimitShowMore: 'Mehr anzeigen',
            }}
          />
        )}
      />
    </FormField>
  );
};

export default MultiSelect;
